import { GoogleSearch } from '@/google-search';

$(document).ready(function() {
    GoogleSearch.init();
});